import { useSearch } from '@tanstack/react-router';
import { EClaimType } from '../lib/types';
import RefundOptionCard from './RefundOptionCard';
import SelectOneOption from './SelectOneOption';
import { refundOptionsArray } from '../lib/constants';
import { useQuery } from '@tanstack/react-query';
import {
  getFacilityPaymentSettings,
  getGlobalPaymentSettings,
} from '../services/payment-settings';
import { getRefundDetails } from '../services/direct';
import { useTranslation } from 'react-i18next';

const RefundOptions = () => {
  const { t } = useTranslation();
  const search = useSearch({ strict: false });

  const globalPaymentSettings = useQuery({
    queryKey: ['globalPaymentSettings'],
    queryFn: getGlobalPaymentSettings,
  });

  const facilityPaymentSettings = useQuery({
    queryKey: ['facilityPaymentSettings'],
    queryFn: getFacilityPaymentSettings,
  });

  const { data: refundData } = useQuery({
    queryKey: ['refundDetails'],
    queryFn: getRefundDetails,
  });

  const refundAmount = +(refundData?.refundData?.refund_amount ?? 0);

  const filteredOptions = refundOptionsArray?.filter((option) => {
    if (!search.claimType) return false;
    return option.allowFor.includes(search.claimType);
  });

  const sortedOptions = filteredOptions?.sort((a, b) => {
    const aExceedsLimit = a.limit && refundAmount > a.limit;
    const bExceedsLimit = b.limit && refundAmount > b.limit;

    if (aExceedsLimit && !bExceedsLimit) return 1;
    if (!aExceedsLimit && bExceedsLimit) return -1;
    return 0;
  });

  const claimTypeSettings =
    search.claimType === EClaimType.EMAIL
      ? 'emailPaymentMethods'
      : 'letterPaymentMethods';

  const availableOptions = sortedOptions?.filter((option) =>
    facilityPaymentSettings.data?.[claimTypeSettings].includes(
      option.refundMethod,
    ),
  );

  return (
    <div className='mt-9 flex w-full flex-col gap-4'>
      <SelectOneOption />
      <div className='flex w-full flex-col gap-4 lg:flex-row lg:flex-wrap lg:items-stretch lg:justify-start'>
        {sortedOptions?.map((option) => (
          <RefundOptionCard
            {...option}
            globalPaymentSettings={globalPaymentSettings}
            facilityPaymentSettings={facilityPaymentSettings}
            claimTypeSettings={claimTypeSettings}
            refundAmount={refundAmount}
          />
        ))}
        {(availableOptions?.length ?? 0) === 0 && (
          <div className='m-32 w-full text-center'>
            <p className='text-foreground'>
              {t('No refund options available for this claim type.')}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RefundOptions;
